<template>
  <div>
    <div
      lang="en"
      class="sign-up-form"
      v-loading="loading"
      element-loading-text="Logging in..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-form-item>
          <el-input
            placeholder="Enter email id"
            v-model="form.email"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="Enter your password"
            v-model="form.password"
            show-password
          ></el-input>
        </el-form-item>
        <div class="forgot-password">
          <el-link @click="forgotPasswordVisible = true"
            >Forgot password ?</el-link
          >
        </div>
        <div style="text-align: right; margin: 30px 0 0 0; display: inline;">
          <el-form-item>
            <el-button @click="onClose" size="small">Cancel</el-button>
            <el-button type="primary" @click="submitForm('form')"
              >Sign In</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div>
      <el-dialog
        :visible.sync="forgotPasswordVisible"
        title="Email"
        width="25%"
        class="forgot-password-popup"
        append-to-body
      >
        <div>
          <el-form
            v-loading="sendEmailLoading"
            element-loading-text="Please wait..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
            @submit.prevent.native="sendEmail"
          >
            <el-input v-model="email"></el-input>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="forgotPasswordVisible = false"
            >Cancel</el-button
          >
          <el-button type="primary" @click="sendEmail">Confirm</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { showMessage, getSocketPayload } from "../utils";
import { Auth } from "aws-amplify";
import "amazon-cognito-identity-js";
import { mapGetters, mapState } from "vuex";
import "cross-fetch/polyfill";

export default {
  name: "Login",
  props: ["onClose"],
  data() {
    return {
      forgotPasswordVisible: false,
      email: ""
    };
  },
  mounted: function() {
    this.listenOnCloseEvent();
  },
  methods: {
    async submitForm() {
      await this.login();
      this.onClose();
    },
    async login() {
      try {
        this.$store.commit("user/setAuthLoading", true);
        const user = await Auth.signIn(
          this.form.email.toLowerCase(),
          this.form.password
        );
        const { idToken, accessToken, refreshToken } = user.signInUserSession;
        const tokens = {
          idToken: idToken.jwtToken,
          accessToken: accessToken.jwtToken,
          refreshToken: refreshToken.token
        };
        showMessage("Logged in successfully", "success");
        localStorage.setItem("user", JSON.stringify(tokens));
        this.$store.commit("user/setTokens", tokens);
        this.$store.commit("user/updateLoginStatus", true);
        this.$store.dispatch("user/getControls", this.mainRoom.name);
        this.$store.commit("user/setAuthLoading", false);
        this.joinPersonalRoom();
      } catch (err) {
        showMessage("Log in failed", "error");
        this.$store.commit("user/setAuthLoading", false);
      }
    },
    async sendEmail() {
      this.$store.commit("user/setSendEmailLoading", true);
      Auth.forgotPassword(this.email.toLowerCase())
        .then(() => {
          this.$store.commit("user/setSendEmailLoading", false);
          this.forgotPasswordVisible = false;
          this.email = "";
          showMessage("Verification email sent.", "success");
        })
        .catch(err => {
          this.$store.commit("user/setSendEmailLoading", false);

          if (err.name === "UserNotFoundException") {
            showMessage("User not found", "error");
          } else {
            showMessage(
              "Something went wrong. Please try again after some time.",
              "error"
            );
          }
        });
    },
    listenOnCloseEvent() {
      this.$eventHub.$on("RESET_FORM", () => {
        this.$store.commit("user/resetUserDataForm");
      });
    },

    joinPersonalRoom() {
      const email = this.profile.email;
      if (!email) return;
      this.socket.emit("JOIN_PERSONAL_ROOM", getSocketPayload({ email }));
    }
  },
  computed: {
    ...mapState({
      form: state => state.user.loginForm,
      loading: state => state.user.authLoading,
      mainRoom: state => state.rooms.mainRoom,
      sendEmailLoading: state => state.user.sendEmailLoading,
      profile: state => state.user.profile
    }),

    ...mapGetters("rooms", {
      socket: "getSocket"
    })
  }
};
</script>

<style scoped>
.forgot-password {
  margin-bottom: 5%;
  display: flex;
  justify-content: flex-end;
}

.email {
  margin-left: 45%;
}

>>> input.el-input__inner,
>>> .el-input.is-disabled .el-input__inner {
  background: #393752;
  border-radius: 3px;
  height: 32px;
  border: none;
  color: #e7e6fa;
}

>>> .el-input .el-input__inner {
  color: #e7e6fa;
}
>>> .el-input .el-input__inner::-webkit-input-placeholder {
  /* Edge */
  color: rgba(231, 230, 250, 0.4);
}

>>> .el-input .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(231, 230, 250, 0.4);
}

>>> .el-input .el-input__inner::placeholder {
  color: rgba(231, 230, 250, 0.4);
}

@media (max-width: 767px) {
    .forgot-password-popup >>>.el-dialog {
        width: 90% !important;
    }
}
</style>
